import moment from "moment"
import OPTooltip from "components/material/tooltip"
import { getIntradayPriceState, INTRADAY_PRICE_STATES } from "helpers/intraday-price-state"
import "./style.scss"

export interface IntradayFreshnessDotProps {
  priceAsOf?: string | null
}

function formatPriceAsOfLabel(priceMoment: moment.Moment, isToday: boolean): string {
  // Prior-dated stamps include the date — a bare time would read as today's.
  return isToday
    ? `Today ${priceMoment.format("LT")}`
    : `Prior ${priceMoment.format("LT")} ${priceMoment.format("MMM D")}`
}

export default function IntradayFreshnessDot({ priceAsOf }: IntradayFreshnessDotProps) {
  // Strict-parse so a malformed value falls through without moment's fallback-parse warning.
  const priceMoment = priceAsOf == null ? null : moment(priceAsOf, moment.ISO_8601, true)

  if (priceMoment == null || !priceMoment.isValid()) {
    // Transparent placeholder keeps IDs aligned with priced rows.
    return <span className="intraday-freshness-dot is-placeholder" aria-hidden="true" />
  }

  const isToday = getIntradayPriceState(priceAsOf) === INTRADAY_PRICE_STATES.TODAY
  const label = formatPriceAsOfLabel(priceMoment, isToday)

  return (
    // The tooltip mirrors its title onto the wrapper as an aria-label, so the
    // color-only dot still reads as "Today/Prior <time>" to assistive tech.
    <OPTooltip enterDelay={300} title={label} placement="bottom-start">
      <span className="intraday-freshness-dot">
        <span className={isToday ? "state-today" : "state-prior"} />
      </span>
    </OPTooltip>
  )
}
